"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.firebase = exports.colors = void 0;
var colors = {
  appBackground: '#000',
  appBackgroundRgb: [0, 0, 0],
  textDefault: '#666666',
  textPrimary: '#D8D8D8',
  textSecondary: '#919191',
  textRed: '#E60046',
  textTitle: '#192C03',
  primary: '#0D9F67',
  text: '#919191',
  primaryContrastText: '#fff',
  secondary: '#DBC8A8',
  secondaryContrastText: '#fff',
  tertiary: '#192C03',
  tertiaryContrastText: '#fff',
  disabled: '#E1E1E1',
  disabledText: '#757575'
};
exports.colors = colors;
var firebase = {
  apiKey: "AIzaSyDfRaEG4JGX0E4Q-1PHrr0fmneK4XJmPG4",
  authDomain: "izzistock-knx.firebaseapp.com",
  databaseURL: "https://izzistock-knx.firebaseio.com",
  projectId: "izzistock-knx",
  storageBucket: "izzistock-knx.appspot.com",
  messagingSenderId: "294464023369",
  appId: "1:294464023369:web:245f14771c9afcb64b4898",
  measurementId: "G-J3J73KJLHG"
};
exports.firebase = firebase;